<template>
    <div>
        <form class="form" novalidate="novalidate" id="st-foreigner-form">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>
                            {{ fields.passport_number.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.passport_number.name]"
                                :ref="fields.passport_number.name"
                                :name="fields.passport_number.name"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.last_name.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.last_name.name]"
                                :ref="fields.last_name.name"
                                :name="fields.last_name.name"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.first_name.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.first_name.name]"
                                :ref="fields.first_name.name"
                                :name="fields.first_name.name"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.country.label }} *
                        </label>
                        <div label="">
                            <st-autocomplete
                                v-model="model[fields.country.name]"
                                :options="fields.country.options"
                                :ref="fields.country.name"
                                :name="fields.country.name"
                                value-field="text"
                                text-field="text"
                                @change="onChange(fields.country)"
                            ></st-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>
                            {{ fields.city.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.city.name]"
                                :ref="fields.city.name"
                                :name="fields.city.name"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.address.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.address.name]"
                                :ref="fields.address.name"
                                :name="fields.address.name"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.email.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.email.name]"
                                :ref="fields.email.name"
                                :name="fields.email.name"
                                :disabled="true"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            {{ fields.phone_number.label }} *
                        </label>
                        <div label="">
                            <st-input-text
                                v-model="model[fields.phone_number.name]"
                                :ref="fields.phone_number.name"
                                :name="fields.phone_number.name"
                                phone-validation
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { ProfileModel } from "@/modules/profile/profile-model";
import { FormSchema } from "@/shared/form/form-schema";
import { createFormValidation } from "@/shared/utils/create-form-validation";

const { fields } = ProfileModel;

const formSchema = new FormSchema([
    fields.id,
    fields.user_type_name,
    fields.passport_number,
    fields.first_name,
    fields.last_name,
    fields.country,
    fields.city,
    fields.address,
    fields.email,
    fields.phone_number,
]);
export default {
    props: {
        user: Object,
    },
    data() {
        return {
            model: null,
            rules: formSchema.rules(),
            fields,
        };
    },
    methods: {
        onChange(field) {
            this.fv.revalidateField(field.name, true);
        },
    },
    created() {
        this.model = formSchema.initialValues(this.user);
        this.model.user_type_name = "foreigner";
    },
    mounted() {
        this.fv = createFormValidation("st-foreigner-form", this.rules);
    },
};
</script>
